import { XIcon } from 'lucide-react';
import { FC, PropsWithChildren } from 'react';
import { cn } from '@/shared/lib';
import { IconButton } from '../IconButton';
import { TruncatedText } from '../TruncatedText';

type Props = PropsWithChildren<{
  /** Название поля */
  label: string;
  /** Название действия удаления: доступное имя и подсказка кнопки */
  removeLabel: string;
  onRemove: () => void;
  disabled?: boolean;
  className?: string;
}>;

/**
 * Поле с названием и удалением над ним — оболочка элемента, добавленного пользователем в набор
 * (атрибутного фильтра на панели, свойства в наборе значений). Поле ввода передаёт потребитель.
 */
export const RemovableField: FC<Props> = ({ label, removeLabel, onRemove, disabled, className, children }) => (
  <div className={cn('flex flex-col gap-1', className)}>
    <div className="flex min-h-6 items-center justify-between gap-2">
      <TruncatedText className="text-sm font-medium">{label}</TruncatedText>
      <IconButton size="icon" icon={<XIcon />} label={removeLabel} onClick={onRemove} disabled={disabled} />
    </div>
    {children}
  </div>
);
